// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  CreateClientCredentialApiV1ClientCredentialPostData,
  CreateClientCredentialApiV1ClientCredentialPostResponse,
  DeleteClientCredentialApiV1ClientCredentialClientSecretIdDeleteData,
  DeleteClientCredentialApiV1ClientCredentialClientSecretIdDeleteResponse,
  ExportClientsheetsApiV1ClientsheetExportGetData,
  ExportClientsheetsApiV1ClientsheetExportGetResponse,
  ExportInvoicesApiV1InvoiceExportGetData,
  ExportInvoicesApiV1InvoiceExportGetResponse,
  GetClientCredentialsApiV1ClientCredentialGetData,
  GetClientCredentialsApiV1ClientCredentialGetResponse,
  GetClientsheetDownloadUrlApiV1ClientsheetDownloadUrlGetData,
  GetClientsheetDownloadUrlApiV1ClientsheetDownloadUrlGetResponse,
  GetInvoiceDownloadUrlApiV1InvoiceDownloadUrlGetData,
  GetInvoiceDownloadUrlApiV1InvoiceDownloadUrlGetResponse,
  GetPriceUpdatePreferenceApiV1PriceUpdatePreferenceGetResponse,
  GetPricingsheetApiV1PricingsheetGetData,
  GetPricingsheetApiV1PricingsheetGetResponse,
  ListClientsheetOverviewsApiV1ClientsheetOverviewGetResponse,
  ListClientsheetsApiV1ClientsheetGetData,
  ListClientsheetsApiV1ClientsheetGetResponse,
  ListInvoicesApiV1InvoiceGetData,
  ListInvoicesApiV1InvoiceGetResponse,
  LoginAccessTokenApiV1LoginAccessTokenPostData,
  LoginAccessTokenApiV1LoginAccessTokenPostResponse,
  ReadSparkspreadPricesApiV1SparkspreadGetResponse,
  ReadUserClientsApiV1UsersClientsGetResponse,
  ReadUserMeApiV1UsersMeGetResponse,
  RecoverPasswordApiV1LoginPasswordRecoveryEmailPostData,
  RecoverPasswordApiV1LoginPasswordRecoveryEmailPostResponse,
  ResetPasswordApiV1LoginResetPasswordPostData,
  ResetPasswordApiV1LoginResetPasswordPostResponse,
  SendContactSupportEmailSendContactSupportEmailPostData,
  SendContactSupportEmailSendContactSupportEmailPostResponse,
  SendMagicLinkApiV1LoginSendMagicLinkPostData,
  SendMagicLinkApiV1LoginSendMagicLinkPostResponse,
  SwitchClientApiV1LoginSwitchClientClientCodePostData,
  SwitchClientApiV1LoginSwitchClientClientCodePostResponse,
  UpdatePriceUpdatePreferenceApiV1PriceUpdatePreferencePutData,
  UpdatePriceUpdatePreferenceApiV1PriceUpdatePreferencePutResponse,
  VerifyMagicLinkApiV1LoginVerifyMagicLinkPostData,
  VerifyMagicLinkApiV1LoginVerifyMagicLinkPostResponse,
} from "./types.gen";

/**
 * Send Contact Support Email
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Message Successful Response
 * @throws ApiError
 */
export const sendContactSupportEmailSendContactSupportEmailPost = (
  data: SendContactSupportEmailSendContactSupportEmailPostData,
): CancelablePromise<SendContactSupportEmailSendContactSupportEmailPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/send-contact-support-email",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read User Me
 * Get current user.
 * @returns AuthenticatedUser Successful Response
 * @throws ApiError
 */
export const readUserMeApiV1UsersMeGet = (): CancelablePromise<ReadUserMeApiV1UsersMeGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/users/me",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read User Clients
 * Get available clients for the current user.
 * @returns ClientPublic Successful Response
 * @throws ApiError
 */
export const readUserClientsApiV1UsersClientsGet =
  (): CancelablePromise<ReadUserClientsApiV1UsersClientsGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/users/clients",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Login Access Token
 * OAuth2 compatible token login endpoint
 * @param data The data for the request.
 * @param data.formData
 * @returns AccessToken Successful login
 * @throws ApiError
 */
export const loginAccessTokenApiV1LoginAccessTokenPost = (
  data: LoginAccessTokenApiV1LoginAccessTokenPostData,
): CancelablePromise<LoginAccessTokenApiV1LoginAccessTokenPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/v1/login/access-token",
    formData: data.formData,
    mediaType: "application/x-www-form-urlencoded",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Recover Password
 * API Password Recovery
 * @param data The data for the request.
 * @param data.email
 * @returns Message Successful Response
 * @throws ApiError
 */
export const recoverPasswordApiV1LoginPasswordRecoveryEmailPost = (
  data: RecoverPasswordApiV1LoginPasswordRecoveryEmailPostData,
): CancelablePromise<RecoverPasswordApiV1LoginPasswordRecoveryEmailPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/v1/login/password-recovery/{email}",
    path: {
      email: data.email,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Reset Password
 * Reset API password
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Message Successful Response
 * @throws ApiError
 */
export const resetPasswordApiV1LoginResetPasswordPost = (
  data: ResetPasswordApiV1LoginResetPasswordPostData,
): CancelablePromise<ResetPasswordApiV1LoginResetPasswordPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/v1/login/reset-password/",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Send Magic Link
 * Magic Link Login
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Message Successful Response
 * @throws ApiError
 */
export const sendMagicLinkApiV1LoginSendMagicLinkPost = (
  data: SendMagicLinkApiV1LoginSendMagicLinkPostData,
): CancelablePromise<SendMagicLinkApiV1LoginSendMagicLinkPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/v1/login/send-magic-link/",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Verify Magic Link
 * Verify Magic Link
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AccessToken Successful Response
 * @throws ApiError
 */
export const verifyMagicLinkApiV1LoginVerifyMagicLinkPost = (
  data: VerifyMagicLinkApiV1LoginVerifyMagicLinkPostData,
): CancelablePromise<VerifyMagicLinkApiV1LoginVerifyMagicLinkPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/v1/login/verify-magic-link/",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Switch Client
 * @param data The data for the request.
 * @param data.clientCode
 * @param data.bciPortalAccessToken
 * @returns AccessToken Successful Response
 * @throws ApiError
 */
export const switchClientApiV1LoginSwitchClientClientCodePost = (
  data: SwitchClientApiV1LoginSwitchClientClientCodePostData,
): CancelablePromise<SwitchClientApiV1LoginSwitchClientClientCodePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/v1/login/switch-client/{client_code}",
    path: {
      client_code: data.clientCode,
    },
    cookies: {
      bci_portal_access_token: data.bciPortalAccessToken,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read Sparkspread Prices
 * @returns ListOfPriceItems Successful Response
 * @throws ApiError
 */
export const readSparkspreadPricesApiV1SparkspreadGet =
  (): CancelablePromise<ReadSparkspreadPricesApiV1SparkspreadGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/sparkspread/",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Get Pricingsheet
 * @param data The data for the request.
 * @param data.bciPortalAccessToken
 * @returns KasPricesheet Successful Response
 * @throws ApiError
 */
export const getPricingsheetApiV1PricingsheetGet = (
  data: GetPricingsheetApiV1PricingsheetGetData = {},
): CancelablePromise<GetPricingsheetApiV1PricingsheetGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/pricingsheet/",
    cookies: {
      bci_portal_access_token: data.bciPortalAccessToken,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * List Clientsheet Overviews
 * @returns ClientsheetOverviewsPublic Successful Response
 * @throws ApiError
 */
export const listClientsheetOverviewsApiV1ClientsheetOverviewGet =
  (): CancelablePromise<ListClientsheetOverviewsApiV1ClientsheetOverviewGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/clientsheet-overview/",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * List Clientsheets
 * @param data The data for the request.
 * @param data.startDate Start date in YYYY-MM-DD format
 * @param data.endDate End date in YYYY-MM-DD format
 * @returns ClientsheetsPublic Successful Response
 * @throws ApiError
 */
export const listClientsheetsApiV1ClientsheetGet = (
  data: ListClientsheetsApiV1ClientsheetGetData = {},
): CancelablePromise<ListClientsheetsApiV1ClientsheetGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/clientsheet/",
    query: {
      start_date: data.startDate,
      end_date: data.endDate,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Export Clientsheets
 * @param data The data for the request.
 * @param data.dates List of dates to export clientsheets as zip
 * @returns binary Successful Response
 * @throws ApiError
 */
export const exportClientsheetsApiV1ClientsheetExportGet = (
  data: ExportClientsheetsApiV1ClientsheetExportGetData,
): CancelablePromise<ExportClientsheetsApiV1ClientsheetExportGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/clientsheet/export",
    query: {
      dates: data.dates,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Clientsheet Download Url
 * @param data The data for the request.
 * @param data.date
 * @returns string Successful Response
 * @throws ApiError
 */
export const getClientsheetDownloadUrlApiV1ClientsheetDownloadUrlGet = (
  data: GetClientsheetDownloadUrlApiV1ClientsheetDownloadUrlGetData,
): CancelablePromise<GetClientsheetDownloadUrlApiV1ClientsheetDownloadUrlGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/clientsheet/download-url",
    query: {
      date: data.date,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * List Invoices
 * @param data The data for the request.
 * @param data.invoiceType
 * @param data.year
 * @param data.month
 * @returns InvoicesPublic Successful Response
 * @throws ApiError
 */
export const listInvoicesApiV1InvoiceGet = (
  data: ListInvoicesApiV1InvoiceGetData = {},
): CancelablePromise<ListInvoicesApiV1InvoiceGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/invoice/",
    query: {
      invoice_type: data.invoiceType,
      year: data.year,
      month: data.month,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Export Invoices
 * @param data The data for the request.
 * @param data.ids List of ids to download invoices as zip
 * @returns binary Successful Response
 * @throws ApiError
 */
export const exportInvoicesApiV1InvoiceExportGet = (
  data: ExportInvoicesApiV1InvoiceExportGetData,
): CancelablePromise<ExportInvoicesApiV1InvoiceExportGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/invoice/export",
    query: {
      ids: data.ids,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Invoice Download Url
 * @param data The data for the request.
 * @param data.id
 * @returns string Successful Response
 * @throws ApiError
 */
export const getInvoiceDownloadUrlApiV1InvoiceDownloadUrlGet = (
  data: GetInvoiceDownloadUrlApiV1InvoiceDownloadUrlGetData,
): CancelablePromise<GetInvoiceDownloadUrlApiV1InvoiceDownloadUrlGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/invoice/download-url",
    query: {
      id: data.id,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Client Credentials
 * @param data The data for the request.
 * @param data.bciPortalAccessToken
 * @returns ClientSecretPublic Successful Response
 * @throws ApiError
 */
export const getClientCredentialsApiV1ClientCredentialGet = (
  data: GetClientCredentialsApiV1ClientCredentialGetData = {},
): CancelablePromise<GetClientCredentialsApiV1ClientCredentialGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/client-credential/",
    cookies: {
      bci_portal_access_token: data.bciPortalAccessToken,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Create Client Credential
 * Create client credential.
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.bciPortalAccessToken
 * @returns CreateClientCredentialResponse Successful Response
 * @throws ApiError
 */
export const createClientCredentialApiV1ClientCredentialPost = (
  data: CreateClientCredentialApiV1ClientCredentialPostData,
): CancelablePromise<CreateClientCredentialApiV1ClientCredentialPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/v1/client-credential/",
    cookies: {
      bci_portal_access_token: data.bciPortalAccessToken,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Delete Client Credential
 * @param data The data for the request.
 * @param data.clientSecretId
 * @param data.bciPortalAccessToken
 * @returns Message Successful Response
 * @throws ApiError
 */
export const deleteClientCredentialApiV1ClientCredentialClientSecretIdDelete = (
  data: DeleteClientCredentialApiV1ClientCredentialClientSecretIdDeleteData,
): CancelablePromise<DeleteClientCredentialApiV1ClientCredentialClientSecretIdDeleteResponse> => {
  return __request(OpenAPI, {
    method: "DELETE",
    url: "/api/v1/client-credential/{client_secret_id}",
    path: {
      client_secret_id: data.clientSecretId,
    },
    cookies: {
      bci_portal_access_token: data.bciPortalAccessToken,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Price Update Preference
 * Get the price update preference for the current user.
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getPriceUpdatePreferenceApiV1PriceUpdatePreferenceGet =
  (): CancelablePromise<GetPriceUpdatePreferenceApiV1PriceUpdatePreferenceGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/price-update-preference/",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Update Price Update Preference
 * Update the price update preference for the current user and selected client.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EstimatedPriceUpdatePreferenceRecord_Output Successful Response
 * @throws ApiError
 */
export const updatePriceUpdatePreferenceApiV1PriceUpdatePreferencePut = (
  data: UpdatePriceUpdatePreferenceApiV1PriceUpdatePreferencePutData,
): CancelablePromise<UpdatePriceUpdatePreferenceApiV1PriceUpdatePreferencePutResponse> => {
  return __request(OpenAPI, {
    method: "PUT",
    url: "/api/v1/price-update-preference/",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};
